import { cmsApiClient } from '@/config/httpClients';
import type {
  BlogDetailedPageDataResponse,
  CMSBlogDetailedPageResponse,
} from './schemas';
import { CMSBlogDetailedPageSchema } from './schemas';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { BlogNotFound } from './BlogNotFound';

const getBlogDetailedContent = async ({
  queryKey,
}: QueryFunctionContext): Promise<BlogDetailedPageDataResponse> => {
  const blogSlug = queryKey[1];

  const response = await cmsApiClient
    .get<CMSBlogDetailedPageResponse>(
      `collections/articles/entries?fields=id,title,date,slug,feature_image,categories,excerpt,content,seo_page_title,seo_description,seo_keywords&filter[slug:is]=${blogSlug}`
    )
    .json();
  const parsedData = CMSBlogDetailedPageSchema.safeParse(response);
  if (!parsedData.success) {
    console.error('ZOD ERROR ==>', parsedData);
  }

  if (response.data.length === 0) {
    throw new BlogNotFound();
  }
  return response.data[0];
};

export { getBlogDetailedContent };
